<template>
    <div class="flex flex-col bg-white border-b border-solid border-grey-lightest">
        <div class="my-1 flex flex-col rounded flex-no-shrink flex-no-grow">
            <div class="flex flex-row flex-no-shrink flex-no-grow">
                <div class="flex flex-col p-2">
                  <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Drug <span class="text-red text-m">*</span></label>
                  <input type="text" v-model="medication.name" @input="fetchDrugData" class="w-64 h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" >
                  <div id="overlay" v-if="showDrugList" @click="removeList()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0); z-index: 10; cursor: pointer;"></div>
                  <ul v-if="showDrugList" id="autocomplete-results" class="autocomplete-results w-64 h-auto z-10 shadow-md">
                    <li v-for="(item, i) in drugList" :key="i" class="autocomplete-result">
                      <div class="p-2" @click="selectDrug(item)">{{ item.name }}</div>
                    </li>
                  </ul>
                </div>
                <div class="flex flex-col ml-auto p-2">
                  <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Dosage </label>
                  <div class="flex flex-row">
                      <input type="number" min="0" :value="medication.dose_quantity" @input="(e) => updateMedication(e, 'dose_quantity')" class="w-16 h-8 p-2 mr-2 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue" style="outline: none">
                      <select :value="medication.dose_unit" @input="(e) => updateMedication(e, 'dose_unit')" class="flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue" name="dosage type" style="outline: none; background-position: 2.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
                        <option value="mg">mg</option>
                        <option value="ml">ml</option>
                        <option value="micro-g">µg</option>
                        <option value="g">g</option>
                        <option value="IU">IU</option>
                      </select>
                  </div>
                </div>
            </div>

            <div class="flex flex-col flex-no-shrink flex-no-grow">
                <div class="flex flex-col mt-2 p-2">
                  <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase"> Frequency <span class="text-red text-m">*</span></label>
                  <div class="flex flex-row">
                    <select :value="medication.frequency" @change="(e) => updateMedication(e, 'frequency')" class="flex appearance-none mr-4 w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue" name="dosage type" style="outline: none;  background-position: 6.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
                      <option value="once">once</option>
                      <option value="twice">twice</option>
                      <option value="thrice">thrice</option>
                      <option value="four times">4 times</option>
                      <option value="five times">5 times</option>
                      <option value="six times">6 times</option>
                      <option value="PRN/SOS">PRN/SOS</option>
                    </select>
                    <select v-if="medication.frequency !== 'PRN/SOS'" :key="medication.frequency" :value="medication.frequency_unit" @change="(e) => updateMedication(e, 'frequency_unit')" class="flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue" name="dosage_type" style="outline: none;  background-position: 6.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
                      <option value="day" selected>day</option>
                      <option value="week">week</option>
                      <option value="month">month</option>
                    </select>
                    <select v-else :value="medication.frequency_unit" @change="(e) => updateMedication(e, 'frequency_unit')" class="flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue" name="dosage_type_day" style="outline: none;  background-position: 6.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
                      <option value="once a day" selected>once a day</option>
                      <option value="twice a day">twice a day</option>
                      <option value="thrice a day">thrice a day</option>
                    </select>
                    <span v-if="frequencyText" class="flex self-center mt-auto ml-4 text-sm text-grey-light">{{frequencyText}}</span>
                  </div>
                </div>

                <div class="flex flex-col mt-2 p-2">
                  <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Duration <span class="text-red text-m">*</span></label>
                  <div class="flex flex-row">
                    <input @input="durationHandler" type="number" min="0" v-model="medication.duration" name="drug_duration" class="w-24 h-8 p-2 mr-4 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue" style="outline: none">
                    <select @change="durationHandler" v-model="medication.duration_unit" class="flex appearance-none w-24 h-8 pl-2 bg-grey-extralight border border-solid rounded-sm border-grey-lightest text-base text-grey-darkest focus:border-blue" name="dosage type" style="outline: none;  background-position: 4.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
                      <option value="day">day</option>
                      <option value="week">week</option>
                      <option value="month">month</option>
                    </select>
                    <span v-if="medication.duration && medication.duration_unit" class="flex self-center mt-auto ml-4 text-sm text-grey-light">{{`for ${medication.duration} ${medication.duration_unit}`}}</span>
                  </div>
                </div>
            </div>
            <div class="flex mt-2 flex-col flex-no-shrink flex-no-grow">
              <TextField label="Route" fieldId='route' :value='medication.route' @input="(e) => updateMedication(e, 'route')" editMode=true key="1" @saveChange="saveChange" />
            </div>

            <div class="flex mt-2 flex-col flex-no-shrink flex-no-grow">
              <TextField label="Special Instructions" fieldId='instructions' :value='medication.instructions' @input="(e) => updateMedication(e, 'instructions')" editMode=true key="2" @saveChange="saveChange" />
            </div>
            <div class="flex my-2 p-2 flex-row flex-no-shrink flex-no-grow">
              <input type="checkbox" v-model="medication.is_current" name="drug_duration" class="h-8 p-2 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue" style="outline: none">
              <label class="p-2 mr-2 text-sm font-semibold text-grey-dark" style="text-transform: uppercase"> Is Current Medication</label>
            </div>
        </div>
        <div class="mt-4 self-center">
          <span @click="cancelEdit()" class="hover:shadow-md cursor-pointer my-3 py-2 px-5 border border-solid border-grey-lightest text-blue font-semibold text-center rounded self-center flex-no-shrink">Cancel</span>
          <span v-if="saved === false" @click="savePrescriptionDetails()" class="hover:shadow-md cursor-pointer border border-solid border-blue bg-blue my-3 py-2 px-5 ml-2 text-white font-semibold text-center rounded self-center flex-no-shrink items-end">Save</span>
          <span v-else-if="saved === true" @click="savePreFilled()" class="hover:shadow-md cursor-pointer border border-solid border-blue bg-blue my-3 py-2 px-5 ml-2 text-white font-semibold text-center rounded self-center flex-no-shrink items-end">Save</span>
        </div>
    </div>
</template>

<script>
import TextField from '@/components/common/TextField'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import {mapGetters} from 'vuex'
import Vue from 'vue'
Vue.use(VueToast)

export default {
  components: {
    TextField
  },
  props: ['customerId', 'consultType', 'saved', 'med'],
  data () {
    return {
      drugList: [],
      showDrugList: false,
      search: '',
      medication: this.med ? {...this.med} : {
        name: '',
        dose_quantity: null,
        dose_unit: '',
        frequency: '',
        frequency_unit: '',
        duration: null,
        duration_unit: '',
        is_current: false,
        route: '',
        instructions: ''
      },
      beforeMed: {...this.med}
    }
  },
  computed: {
    ...mapGetters({
      currentDrug: 'consultation/getCurrentDrug'
    }),
    frequencyText: function () {
      if (!this.medication.frequency) return null
      let frequencyText = this.medication.frequency
      frequencyText = frequencyText !== 'PRN/SOS' ? `${this.medication.frequency} a ${this.medication.frequency_unit}` : `${this.medication.frequency}(Only if symptoms are there) ${this.medication.frequency_unit}`
      return frequencyText
    },
    editedMedData: function () {
      return Object.keys(this.medication).reduce((med, field) => {
        if (this.medication[field] !== this.beforeMed[field]) {
          med[field] = this.medication[field]
        }
        return med
      }, {})
    }
  },
  created () {
    if (this.consultType === 'online' && !this.med) {
      this.medication = this.currentDrug
    } else if (this.med) {
      this.medication = this.med
    }
  },
  methods: {
    updateMedication: function (e, option) {
      if (option === 'dose_quantity') {
        this.medication.dose_quantity = e.target.value
      } else if (option === 'dose_unit') {
        this.medication.dose_unit = e.target.value
      } else if (option === 'frequency') {
        this.handleFrequencyChange(e)
      } else if (option === 'frequency_unit') {
        this.medication.frequency_unit = e.target.value
      } else if (option === 'route') {
        this.medication.route = e.target
      } else if (option === 'instructions') {
        this.medication.instrcutions = e.target
      }
      if (this.consultType === 'online') {
        this.$store.commit('consultation/storeDrugs', {drugs: this.medication, channelId: this.customerId, isAdding: true})
      }
    },
    handleFrequencyChange: function (e) {
      const newValue = e.target.value
      const previousValue = this.medication.frequency

      if ((previousValue === 'PRN/SOS' && newValue !== 'PRN/SOS') ||
          (previousValue !== 'PRN/SOS' && newValue === 'PRN/SOS') || previousValue === '' || previousValue === null) {
        this.medication.frequency_unit = newValue === 'PRN/SOS' ? 'once a day' : 'day'
      }

      this.medication.frequency = newValue
    },
    saveChange: function (data) {
      let keys = Object.keys(data)
      let values = Object.values(data)
      this.medication[keys[0]] = values[0]
    },
    cancelEdit: function () {
      this.$emit('updateDrugs')
      this.$emit('updateSavedDrugs')
    },
    removeDrugs: function () {
      this.$store.dispatch('consultation/removeDrugs', {customerId: this.customerId})
    },
    fetchDrugData (e) {
      let customerId = this.customerId
      var vm = this
      if (this.medication.name && this.medication.name.length > 2) {
        this.$http.get(window.API_URL + 'doctors/medicines/search-drugs?search_term=' + this.medication.name + '&customer_id=' + customerId).then(response => {
          if (response.status === 200) {
            vm.drugList = response.body.drugs
            if (response.body.drugs.length !== 0) {
              vm.showDrugList = true
            } else {
              vm.showDrugList = false
            }
          } else {
          }
        }, response => {
        })
      } else {
        vm.drugList = []
        vm.showDrugList = false
      }
    },
    removeList: function () {
      this.showDrugList = false
    },
    selectDrug: function (drug) {
      this.medication.name = drug.name
      if (this.consultType === 'online') {
        this.$store.dispatch('consultation/storeDrugs', {drugs: this.medication, channelId: this.customerId, isAdding: true})
      }
      this.showDrugList = false
    },
    durationHandler: function () {
      switch (this.medication.duration_unit) {
        case 'day':
          this.medication.number_of_days = this.medication.duration
          break
        case 'week':
          this.medication.number_of_days = this.medication.duration * 7
          break
        case 'month':
          this.medication.number_of_days = this.medication.duration * 30
          break
      }
    },
    savePreFilled: function () {
      let canSave = true
      let validDrugName = true
      if (this.medication.name.length > 100) {
        validDrugName = false
      }
      if (!this.medication.name || !this.medication.frequency || !this.medication.duration || !this.medication.duration_unit) {
        canSave = false
      }
      if (!this.medication.frequency_unit) {
        canSave = false
      }
      if (canSave && validDrugName && !this.med) {
        this.$emit('updateSavedDrugs', {
          name: this.medication.name,
          dose_quantity: this.medication.dose_quantity ? this.medication.dose_quantity : '',
          dose_unit: this.medication.dose_unit ? this.medication.dose_unit : '',
          frequency: this.frequencyText,
          number_of_days: this.medication.number_of_days,
          date: this.medication.date,
          duration: this.medication.duration,
          duration_unit: this.medication.duration_unit,
          isActive: this.medication.isActive,
          route: this.medication.route ? this.medication.route.trim() : null,
          instructions: this.medication.instructions ? this.medication.instructions.trim() : null,
          is_current: this.medication.is_current
        })
      }
      if (canSave && validDrugName && this.med) {
        if (Object.keys(this.editedMedData).length === 0) {
          this.cancelEdit()
        } else {
          this.$emit('editSavedDrug', this.editedMedData)
        }
      } else if (!validDrugName) {
        this.$toast.open({
          message: 'Drug name should not be too long',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      } else {
        this.$toast.open({
          message: 'Please fill all mandatory fields',
          type: 'warning',
          position: 'top',
          queue: false
        })
      }

      let medication = {}
      if (this.consultType === 'online') {
        this.$store.dispatch('consultation/storeDrugs', {drugs: medication, channelId: this.customerId, isAdding: false})
      }
    },
    savePrescriptionDetails: function () {
      let canSave = true
      let validDrugName = true
      if (this.medication.name.length > 100) {
        validDrugName = false
      }
      if (!this.medication.name || !this.medication.frequency || !this.medication.duration || !this.medication.duration_unit) {
        canSave = false
      }
      if (!this.medication.frequency_unit) {
        canSave = false
      }
      if (canSave && validDrugName) {
        this.$emit('updateDrugs', {
          name: this.medication.name,
          dose_quantity: this.medication.dose_quantity ? this.medication.dose_quantity : '',
          dose_unit: this.medication.dose_unit ? this.medication.dose_unit : '',
          frequency: this.frequencyText,
          number_of_days: this.medication.number_of_days,
          date: this.medication.date,
          duration: this.medication.duration,
          duration_unit: this.medication.duration_unit,
          isActive: this.medication.isActive,
          route: this.medication.route ? this.medication.route.trim() : null,
          instructions: this.medication.instructions ? this.medication.instructions.trim() : null,
          is_current: this.medication.is_current
        }, this.customerId)
        if (this.consultType === 'online') {
          this.$store.commit('consultation/storeCurrentDrugs', {drug: this.medication, customerId: this.customerId})
        } else if (this.consultType === 'offline') {
          this.$store.commit('offlineConsultation/storeCurrentDrugs', {drug: this.medication, customerId: this.customerId})
        }
        let medication = {
          name: null,
          dose_quantity: '',
          dose_unit: '',
          frequency: null,
          frequency_unit: null,
          date: null,
          duration: null,
          duration_unit: null,
          number_of_days: 0,
          isActive: true,
          route: null,
          instructions: null,
          is_current: false
        }
        if (this.consultType === 'online') {
          this.$store.dispatch('consultation/storeDrugs', {drugs: medication, channelId: this.customerId, isAdding: false})
        }
      } else if (!validDrugName) {
        this.$toast.open({
          message: 'Drug name should not be too long',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      } else {
        alert('Please fill all mandatory fields')
      }
    }
  }
}
</script>

<style scoped>
.autocomplete-results {
  position: absolute;
  padding: 0;
  margin: 0;
  border: 1px solid #dae1e7;
  /* height: 100px; */
  overflow: auto;
  /* width: 100%; */
  background: #fff;
  margin-top: 55px;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #2168f3;
  color: white;
}
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/AddDrug.vue